import { z } from 'zod';
import { BANDERAS_SALUD, ESTADOS_SUGERENCIA } from '../enums.js';
// ---------------------------------------------------------------------------
// Sugerencia — el mensaje que propone el sistema (Etapa 1 fijo, o detector+
// redactor por LLM desde Etapa 2), para que Ailen revise, edite y mande desde
// el compositor. Nunca se manda sola (Ciclo 2, D-023/024/025).
// ---------------------------------------------------------------------------
export const confianzaSchema = z.enum(['alta', 'media', 'baja']);
export const sugerenciaPublicSchema = z.object({
    id: z.string(),
    leadId: z.string(),
    etapaDetectada: z.number().int().min(1).max(5),
    motivo: z.string(),
    texto: z.string(),
    evidencia: z.string().nullable(),
    confianza: confianzaSchema.nullable(),
    banderaSalud: z.enum(BANDERAS_SALUD),
    modelo: z.string().nullable(),
    estado: z.enum(ESTADOS_SUGERENCIA),
    creadoEn: z.string(),
    // Calificación de 1 a 5 estrellas (Ailen/Javier), para medir con el tiempo qué
    // prompt/etapa anda mal. null = todavía sin calificar.
    calificacion: z.number().int().min(1).max(5).nullable(),
    calificadoPorId: z.string().nullable(),
    calificadoEn: z.string().nullable(),
});
// Calificar una sugerencia (1 a 5 estrellas). Re-calificar pisa la anterior (sin
// historial) — alcance MVP.
export const sugerenciaCalificarSchema = z.object({
    calificacion: z.number().int().min(1).max(5),
});
//# sourceMappingURL=sugerencia.js.map